import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Modal, Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import "./list_item_invoice_work_order.css";
import { IoAddCircleSharp } from "react-icons/io5";


interface ListItemType {
    id: React.Key;
    key: React.Key;
    type: string;
    job_type: string;
    item_no: string;
    description: string;
    qty: number;
    uom: string;
}

const ListItemInvoiceWorkOrder = forwardRef((props: { form: any, existingItems?: string[], onAddItems?: (selectedKeys: React.Key[], allModalItems: ListItemType[]) => void }, ref) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<ListItemType[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const Addbtn = IoAddCircleSharp as React.ComponentType<any>;
    useImperativeHandle(ref, () => ({ showModal: () => setVisible(true) }));
    const fetchData = async () => {
        const invoiceNo = props.form.getFieldValue("invoice_work_order_no");
        if (!invoiceNo || !visible) return;
        setLoading(true);
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/invoice-return/items/${invoiceNo}`);
            setData(res.data.map((item: any) => ({ ...item, key: item.id })));
        } catch (err) { console.error(err); }
        setLoading(false);
    };
    useEffect(() => { fetchData(); }, [visible]);
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
            <div style={{ padding: 8 }}>
                <Input placeholder={`Search ${dataIndex}`} value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => confirm()} style={{ marginBottom: 8, display: 'block' }} />
                <Space><Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>Search</Button>
                    <Button onClick={() => clearFilters && clearFilters()} size="small" style={{ width: 90 }}>Reset</Button></Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value: any, record: any) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    });
    const isRowDisabled = (record: ListItemType) => props.existingItems?.includes(record.item_no);
    const columns = [
        { title: 'Type', dataIndex: 'type', key: 'type', sorter: (a: any, b: any) => a.type.localeCompare(b.type), ...getColumnSearchProps('type') },
        { title: 'Job Type', dataIndex: 'job_type', key: 'job_type', sorter: (a: any, b: any) => a.job_type.localeCompare(b.job_type), ...getColumnSearchProps('job_type') },
        { title: 'Item No', dataIndex: 'item_no', key: 'item_no', sorter: (a: any, b: any) => a.item_no.localeCompare(b.item_no), ...getColumnSearchProps('item_no') },
        { title: 'Description', dataIndex: 'description', key: 'description', sorter: (a: any, b: any) => a.description.localeCompare(b.description), ...getColumnSearchProps('description') },
        { title: 'Qty', dataIndex: 'qty', key: 'qty', sorter: (a: any, b: any) => a.qty - b.qty, ...getColumnSearchProps('qty') },
        { title: 'UoM', dataIndex: 'uom', key: 'uom', sorter: (a: any, b: any) => a.uom.localeCompare(b.uom), ...getColumnSearchProps('uom') },
    ];
    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record: ListItemType) => ({
            disabled: isRowDisabled(record),
            name: record.item_no,
        }),
    };
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    return (
        <Modal title="List Item Invoice" open={visible} onCancel={() => setVisible(false)} width={1000} footer={null}>
            <div id="is4l" style={transformStyle}>
                <div className="gjs-grid-row" id="iwnay">
                    <div className="gjs-grid-column" id="inguk">
                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={data}
                            loading={loading}
                            bordered size="small"
                            rowClassName={(record) => isRowDisabled(record) ? 'row-disabled-gray' : ''}
                        />
                        <Button
                            className="gr-button"
                            onClick={() => {
                                if (props.onAddItems) {
                                    props.onAddItems(selectedRowKeys, data);
                                }
                                setVisible(false);
                                setSelectedRowKeys([]);
                            }}
                            disabled={selectedRowKeys.length === 0}
                        >
                            <Addbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                            Add Item
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
});
export default ListItemInvoiceWorkOrder;